module.exports = __webpack_public_path__ + "assets/img/3.9841830b.jpg";